import React from "react";
import styles from "./Button.module.css";

/**
 * Button
 * props:
 * - variant: 'primary' | 'secondary' | 'ghost' (default: 'primary')
 * - size: 'md' | 'sm' (default: 'md')
 * - loading: boolean
 * - icon: React node OR string (url)
 * - children
 * - ...props (e.g. onClick, type)
 */

// Pequeno utilitário interno (substitui classnames)
function cx(...classes) {
  return classes.filter(Boolean).join(" ");
}

export const Button = ({
  variant = "primary",
  size = "md",
  loading = false,
  icon = null,
  children,
  className,
  ...props
}) => {
  const isIconUrl = typeof icon === "string" && icon.length > 0;

  return (
    <button
      className={cx(
        styles.button,
        styles[`variant_${variant}`],
        styles[`size_${size}`],
        loading && styles.loading,
        className
      )}
      disabled={loading || props.disabled}
      aria-busy={loading ? "true" : undefined}
      {...props}
    >
      {/* Ícone à esquerda */}
      {icon ? (
        isIconUrl ? (
          <img src={icon} alt="" className={styles.icon} aria-hidden />
        ) : (
          <span className={styles.icon} aria-hidden>
            {icon}
          </span>
        )
      ) : null}

      {/* Label / Spinner */}
      <span className={styles.label}>
        {loading ? <span className={styles.spinner} aria-hidden /> : children}
      </span>
    </button>
  );
};

export default Button;
